// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-group {
    padding-bottom: 1rem;
}

.btn {
    width: 100%;
    border-radius: 50px;
    background: #FF9600;
    color: white;
    margin-bottom: 8px;
    cursor: pointer;
}


.modal-body {
    padding: 2rem;
    padding-top: 5rem;
}

.form-title {
    padding-bottom: 1rem;
}

.changecolor {
    color: #0093A2;
    cursor: pointer;
}

input {
    padding: 1rem;
    border: 1px solid #B0B0B0;
}

.labeltext {
    color: black;
}

.textcolor {
    color: #848484;
}

.pbc {
    padding-bottom: 2rem;
}

.pbl {
    padding-bottom: 3rem;
}

.divider {
    border: 1px solid #B0B0B0;

}

.small-border {
    height: 2px;
    background: #D9D9D9;
    border-left: none;
    border-right: none;
    display: block;
    margin: 0 auto;
    margin-top: 8px;
    padding-top: -33px;
    width: 31%;
}

.btngoogle {
    border: 1px solid #B0B0B0;
    border-radius: 8px;
    padding: 13px;
    background: transparent;
    box-shadow: 0px 10px 15px -5px rgba(0, 0, 0, 0.1), 0px 0px 0px 0px rgba(0, 0, 0, 0.1);
    margin-bottom: 1rem;
    cursor: pointer;
}

.flex-containerbutton {
    display: flex;
    gap: 40px;
}

.img {
    margin-left: 2rem;
    cursor: pointer;
}

.flex-container {
    margin-bottom: 1rem;
    display: flex;
}

.close {
    border: none;
    border-radius: 17px;
    font-size: 14px;
}


.password-div {
    position: relative;

}

.eye-b {
    color: #292929;
    position: absolute;
    top: 37px;
    right: 20px;
    font-size: 20px;
}

.modal-header {
    justify-content: flex-end;
}

.text {
    cursor: pointer;
}

.modal-dialog-no-shadow {
    box-shadow: none !important;
}

@media screen and (max-width: 500px) {
    .flex-containerbutton {
        gap: 13px;
    }
}

.modal-login {
    backdrop-filter: blur(1.5px) !important;
}

.position-close{
    position: absolute;
    top: -3.5rem;
    right: -1rem;
    cursor: pointer;
    color: #FF9602;
}

.div-position-close{
    position: relative;
}

@media screen and (max-width: 500px) {
    .position-close{
        top: -2rem;
        right: -1rem;
    }
}

.warning-messages {
    margin-top: 3px;
    font-size: 0.875em; /* Ajusta el tamaño de la fuente si es necesario */
  }
  
  .error-message {
    display: inline;
  }`, "",{"version":3,"sources":["webpack://./src/app/components/forgot-password/forgot-password.component.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,qFAAqF;IACrF,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;;AAGA;IACI,kBAAkB;;AAEtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,UAAU;QACV,YAAY;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB,EAAE,kDAAkD;EACxE;;EAEA;IACE,eAAe;EACjB","sourcesContent":[".form-group {\n    padding-bottom: 1rem;\n}\n\n.btn {\n    width: 100%;\n    border-radius: 50px;\n    background: #FF9600;\n    color: white;\n    margin-bottom: 8px;\n    cursor: pointer;\n}\n\n\n.modal-body {\n    padding: 2rem;\n    padding-top: 5rem;\n}\n\n.form-title {\n    padding-bottom: 1rem;\n}\n\n.changecolor {\n    color: #0093A2;\n    cursor: pointer;\n}\n\ninput {\n    padding: 1rem;\n    border: 1px solid #B0B0B0;\n}\n\n.labeltext {\n    color: black;\n}\n\n.textcolor {\n    color: #848484;\n}\n\n.pbc {\n    padding-bottom: 2rem;\n}\n\n.pbl {\n    padding-bottom: 3rem;\n}\n\n.divider {\n    border: 1px solid #B0B0B0;\n\n}\n\n.small-border {\n    height: 2px;\n    background: #D9D9D9;\n    border-left: none;\n    border-right: none;\n    display: block;\n    margin: 0 auto;\n    margin-top: 8px;\n    padding-top: -33px;\n    width: 31%;\n}\n\n.btngoogle {\n    border: 1px solid #B0B0B0;\n    border-radius: 8px;\n    padding: 13px;\n    background: transparent;\n    box-shadow: 0px 10px 15px -5px rgba(0, 0, 0, 0.1), 0px 0px 0px 0px rgba(0, 0, 0, 0.1);\n    margin-bottom: 1rem;\n    cursor: pointer;\n}\n\n.flex-containerbutton {\n    display: flex;\n    gap: 40px;\n}\n\n.img {\n    margin-left: 2rem;\n    cursor: pointer;\n}\n\n.flex-container {\n    margin-bottom: 1rem;\n    display: flex;\n}\n\n.close {\n    border: none;\n    border-radius: 17px;\n    font-size: 14px;\n}\n\n\n.password-div {\n    position: relative;\n\n}\n\n.eye-b {\n    color: #292929;\n    position: absolute;\n    top: 37px;\n    right: 20px;\n    font-size: 20px;\n}\n\n.modal-header {\n    justify-content: flex-end;\n}\n\n.text {\n    cursor: pointer;\n}\n\n.modal-dialog-no-shadow {\n    box-shadow: none !important;\n}\n\n@media screen and (max-width: 500px) {\n    .flex-containerbutton {\n        gap: 13px;\n    }\n}\n\n.modal-login {\n    backdrop-filter: blur(1.5px) !important;\n}\n\n.position-close{\n    position: absolute;\n    top: -3.5rem;\n    right: -1rem;\n    cursor: pointer;\n    color: #FF9602;\n}\n\n.div-position-close{\n    position: relative;\n}\n\n@media screen and (max-width: 500px) {\n    .position-close{\n        top: -2rem;\n        right: -1rem;\n    }\n}\n\n.warning-messages {\n    margin-top: 3px;\n    font-size: 0.875em; /* Ajusta el tamaño de la fuente si es necesario */\n  }\n  \n  .error-message {\n    display: inline;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
